import React, {useState, useEffect} from "react";

export default function FleecejackePrimoFront({
  lightContrast,
  darkContrast,
  stitching,
  patchColor,
  azomo,
  printStyle,
  getDataFromChild,
  preview,
}) {
  function adjust(color, amount) {
    return (
      "#" +
      color
        .replace(/^#/, "")
        .replace(/../g, (color) =>
          (
            "0" + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)
          ).substr(-2)
        )
    );
  }

  const [darkenColor, setDarkenColor] = useState(lightContrast);
  const [darkenColorContrast, setDarkenColorContrast] = useState(darkContrast);

  const [lightContrastActive, setLightContrastActive] = useState(false);
  const [darkContrastActive, setDarkContrastActive] = useState(false);
  const [stitchingActive, setStitchingActive] = useState(false);
  const [patchActive, setPatchActive] = useState(false);
  const [azomoActive, setAzomoActive] = useState(false);

  const handleClick = (tabId) => {
    if (!preview) {
      getDataFromChild(tabId);
    }
  };

  useEffect(() => {
    setDarkenColor(adjust(lightContrast, -50));
    setDarkenColorContrast(adjust(darkContrast, -100));
  }, [lightContrast, darkContrast]);

  return (
    <svg
      className={printStyle}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 500 500"
      enableBackground="new 0 0 500 500"
    >
      <g>
        <path
          fill={lightContrast}
          onClick={() => handleClick("base")}
          onMouseEnter={() => setLightContrastActive(true)}
          onMouseLeave={() => setLightContrastActive(false)}
          style={
            lightContrastActive && !preview
              ? {fill: adjust(lightContrast, 55)}
              : {fill: lightContrast}
          }
          d="M451.011,446.638c-0.21-3.209-3.389-51.19-6.28-62.74c-3.019-12.08-6.99-40.92-7.99-51.95
     c-1.02-11.16-14.01-85.07-17.029-92.1c-1.231-2.88-5.59-18.74-10.63-37.1c-7.061-25.7-15.841-57.68-19.37-65.9
     c-4.09-9.57-9.67-18.33-12.67-23.03c-1.21-1.91-2.25-3.55-2.301-3.84c0-1.36-11.89-11.23-23.379-16.969
     c-11.36-5.681-47.011-15.321-50.551-16.271c0.551-2.149,1.01-4.34,1.45-6.46c0.22-1.05,0.441-2.099,0.67-3.15
     c0.191-0.869,0.451-1.77,0.691-2.63c0.649-2.27,1.32-4.62,1.01-7.06c-1.121-8.71-11.281-9.94-18.701-10.84
     c-1.059-0.13-2.08-0.25-3.009-0.39c-2.39-0.36-4.821-0.77-7.17-1.18c-4.651-0.79-9.451-1.61-14.231-2.01
     c-6.599-0.54-13.889-0.5-21.659,0.12c-6.49,0.52-13.11,1.41-20.261,2.72c-1.33,0.24-2.659,0.5-3.989,0.77
     c-0.74,0.14-1.5,0.29-2.261,0.43c-3.21,0.621-6.54,1.26-9.62,2.34c-3.58,1.25-5.75,3.64-6.269,6.91
     c-0.611,3.88,0.299,7.76,1.179,11.51l0.27,1.12c0.621,2.68,1.281,5.3,1.971,7.8c-3.581,0.97-39.19,10.59-50.541,16.271
     c-11.49,5.739-23.379,15.609-23.379,16.949c-0.051,0.31-1.1,1.95-2.311,3.86c-2.99,4.7-8.569,13.46-12.67,23.03
     c-3.519,8.22-12.309,40.2-19.369,65.9c-5.041,18.36-9.391,34.22-10.631,37.1c-3.01,7.03-16.01,80.94-17.019,92.1
     c-1.01,11.03-4.981,39.87-7.991,51.95c-2.889,11.55-6.07,59.531-6.279,62.74c-0.131,0.11-0.221,0.27-0.23,0.46
     c-0.02,0.31,0.139,0.581,0.42,0.67c18.65,6.44,31.379,8.17,39.66,8.17c4.24,0,7.309-0.45,9.42-0.96
     c0.599-0.139,1.019-0.66,1.109-1.34l0.03,0.01c0.031-0.17,0.87-4.67,2.13-11.37l0.051-0.08c-0.011,0-0.021-0.01-0.03-0.01
     c3.67-19.41,10.929-57.17,12.909-62.72c2.261-6.31,17.4-62.2,19.35-72.94c1.411-7.74,10.54-35.25,16.23-50.58
     c-0.1,13.3-1.01,73.95-1.02,74.59l-1.92,74.56c-0.009,0.14-1.65,13.5-1.49,20.491c0.1,4.409,6.17,8,11.25,10.229
     c3.5,1.54,7.25,2.54,11.141,2.97l64.01,7.04c0.58,0.06,1.16,0.13,1.73,0.2c1.42,0.17,2.89,0.34,4.34,0.45h0.09
     c0.939,0.07,1.949,0.14,2.949,0.14c0.961,0,1.91-0.06,2.811-0.26c0.379-0.08,0.939-0.23,1.379-0.599
     c0.491-0.401,0.821-1.041,0.941-1.861c0.01-0.03,0.01-0.07,0.01-0.11c0.249-0.042,0.722-0.111,1.364-0.17
     c0.123,0.821,0.825,1.453,1.679,1.453h0.886c0.867,0,1.575-0.649,1.684-1.487c0.364,0.024,0.737,0.053,1.128,0.095
     c0.14,0.539,0.63,1.769,2.34,2.399c0.619,0.23,1.33,0.23,1.949,0.23h0.431c1.08,0,2.16-0.06,3.08-0.12
     c2.309-0.16,4.639-0.41,6.889-0.66l0.731-0.08c4.8-0.53,9.599-1.05,14.41-1.57l18.529-1.99c2.891-0.31,5.84-0.57,8.7-0.82
     c7.54-0.67,15.34-1.37,22.861-3.02l0.82-0.18c6.56-1.43,18.77-4.09,18.949-12.279c0.031-1.422-0.012-3.101-0.099-4.874
     c0.205-0.337,0.378-0.678,0.512-1.016l-0.418-0.166c-0.041,0.103-0.092,0.206-0.14,0.309c-0.066-1.176-0.148-2.38-0.241-3.574
     c0.138-0.31,0.258-0.62,0.337-0.929l-0.419-0.107c-0.228-2.759-0.495-5.377-0.702-7.294c-0.219-1.99-0.359-4.04-0.41-6.11
     l-1.83-71.29c-0.01-0.64-0.93-61.29-1.029-74.59c5.689,15.33,14.83,42.84,16.24,50.58c1.949,10.74,17.079,66.63,19.34,72.94
     c1.989,5.55,9.25,43.31,12.92,62.72c-0.01,0-0.021,0.01-0.03,0.01l0.04,0.08c1.269,6.7,2.099,11.2,2.139,11.37l0.021-0.01
     c0.099,0.68,0.519,1.201,1.119,1.34c2.1,0.51,5.181,0.96,9.42,0.96c8.281,0,21.011-1.73,39.66-8.17c0.27-0.089,0.44-0.36,0.42-0.67
     C451.231,446.908,451.141,446.748,451.011,446.638z"
        />
        <path
          fill={darkenColor}
          d="M450.497,447.148l-0.02,0.01c-28.041,9.68-42.56,8.66-48.72,7.19c-0.44-0.1-0.62-0.52-0.651-0.881
     c-0.019-0.369,0.101-0.859,0.551-1.039c12.91-5.26,24.88-6.65,33.91-6.65C442.707,445.778,448.017,446.648,450.497,447.148"
        />
        <path
          fill={darkenColor}
          d="M100.317,453.467c-0.03,0.36-0.211,0.78-0.641,0.881c-6.16,1.47-20.67,2.49-48.66-7.21
     c5.721-1.16,25.75-4.091,48.75,5.29C100.216,452.608,100.346,453.098,100.317,453.467"
        />
        <path
          fill={darkenColor}
          d="M302.757,54.217c-0.68,1.541-5.689,12.431-13.77,12.971c-8.85,0.58-21.33-0.361-21.429-0.37
     c-0.381-0.05-9.231-1.31-10.91-0.92c-1.471,0.33-1.971,1.7-2.021,2.399l-0.11,374.721c-3.34-0.33-5.72-0.051-6.63,0.099
     c0.05-0.65,0.06-1.299,0.06-1.939l0.1-372.881l-0.02-0.109c-0.02-0.061-0.56-1.481-2.45-1.92c-1.78-0.42-11.929,0.51-12.36,0.55
     c-0.12,0.009-11.93,0.95-20.77,0.37c-8.12-0.54-13.28-11.191-13.93-12.611c1.1-2.559,3.381-3.899,5.301-4.569
     c3.029-1.061,6.33-1.7,9.529-2.311c0.76-0.139,1.51-0.29,2.26-0.439c1.33-0.261,2.65-0.52,3.98-0.761
     c7.12-1.309,13.731-2.2,20.2-2.71c7.73-0.62,14.98-0.66,21.54-0.12c4.76,0.391,9.55,1.21,14.18,2.011
     c2.35,0.399,4.78,0.81,7.19,1.17c0.93,0.14,1.951,0.26,3.02,0.39C291.817,47.978,299.786,48.967,302.757,54.217"
        />
        <path
          fill={lightContrast}
          onClick={() => handleClick("base")}
          onMouseEnter={() => setLightContrastActive(true)}
          onMouseLeave={() => setLightContrastActive(false)}
          style={
            lightContrastActive && !preview
              ? {fill: adjust(lightContrast, 55)}
              : {fill: lightContrast}
          }
          d="M334.707,389.928c-10.101-35.33-14.34-68.271-15.79-82L334.707,389.928z"
        />
        <path
          fill={lightContrast}
          onClick={() => handleClick("base")}
          onMouseEnter={() => setLightContrastActive(true)}
          onMouseLeave={() => setLightContrastActive(false)}
          style={
            lightContrastActive && !preview
              ? {fill: adjust(lightContrast, 55)}
              : {fill: lightContrast}
          }
          d="M182.627,307.928c-1.45,13.729-5.69,46.67-15.79,81.989L182.627,307.928z"
        />
        <rect x="250.567" y="402.017" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.568" y="400.485" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.569" y="398.953" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.627" y="401.259" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.628" y="399.727" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.629" y="398.195" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.561" y="414.287" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.562" y="412.754" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.563" y="411.222" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.564" y="409.69" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.564" y="408.158" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.565" y="406.625" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.566" y="405.093" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.567" y="403.561" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.621" y="413.529" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.622" y="411.997" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.623" y="410.464" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.624" y="408.931" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.624" y="407.399" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.625" y="405.867" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.626" y="404.334" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.627" y="402.802" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.555" y="426.553" fill="#010101" width="2.297" height="0.661" />
        <rect x="250.556" y="425.02" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.557" y="423.488" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.558" y="421.956" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.558" y="420.423" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.559" y="418.891" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.56" y="417.359" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.561" y="415.827" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.615" y="425.794" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.616" y="424.262" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.617" y="422.73" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.618" y="421.198" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.618" y="419.664" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.619" y="418.132" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.62" y="416.6" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.621" y="415.068" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.55" y="438.802" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.551" y="437.27" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.551" y="435.738" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.552" y="434.206" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.552" y="432.673" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.553" y="431.141" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.554" y="429.609" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.555" y="428.077" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.61" y="438.045" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.61" y="436.512" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.611" y="434.98" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.612" y="433.447" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.613" y="431.914" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.613" y="430.382" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.614" y="428.85" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.615" y="427.318" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.639" y="250.171" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.64" y="248.639" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.64" y="247.107" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.699" y="249.413" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.7" y="247.881" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.7" y="246.348" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.633" y="262.441" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.634" y="260.909" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.634" y="259.377" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.635" y="257.844" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.636" y="256.312" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.637" y="254.78" fill="#010101" width="2.297" height="0.661" />
        <rect x="250.637" y="253.247" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.638" y="251.715" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.693" y="261.683" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.694" y="260.151" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.695" y="258.618" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.695" y="257.085" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.696" y="255.553" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.697" y="254.021" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.697" y="252.489" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.698" y="250.957" fill="#010101" width="2.297" height="0.661" />
        <rect x="250.628" y="274.708" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.628" y="273.174" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.629" y="271.642" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.63" y="270.11" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.631" y="268.578" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.631" y="267.045" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.632" y="265.513" fill="#010101" width="2.297" height="0.661" />
        <rect x="250.633" y="263.981" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.687" y="273.949" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.688" y="272.417" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.689" y="270.884" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.69" y="269.352" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.69" y="267.819" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.691" y="266.287" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.692" y="264.754" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.692" y="263.222" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.622" y="286.957" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.622" y="285.424" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.623" y="283.892" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.624" y="282.36" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.625" y="280.828" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.625" y="279.295" fill="#010101" width="2.297" height="0.661" />
        <rect x="250.626" y="277.763" fill="#010101" width="2.297" height="0.661" />
        <rect x="250.627" y="276.231" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.681" y="286.199" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.682" y="284.666" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.683" y="283.134" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.684" y="281.601" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.684" y="280.069" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.685" y="278.537" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.686" y="277.004" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.687" y="275.472" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.616" y="299.211" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.617" y="297.679" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.617" y="296.147" fill="#010101" width="2.297" height="0.661" />
        <rect x="250.618" y="294.614" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.619" y="293.082" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.62" y="291.549" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.62" y="290.017" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.621" y="288.485" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.675" y="298.453" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.676" y="296.92" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.677" y="295.388" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.678" y="293.856" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.678" y="292.324" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.679" y="290.791" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.68" y="289.258" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.681" y="287.726" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.61" y="311.481" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.611" y="309.949" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.611" y="308.416" fill="#010101" width="2.297" height="0.661" />
        <rect x="250.612" y="306.883" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.613" y="305.351" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.614" y="303.819" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.614" y="302.287" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.615" y="300.754" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.67" y="310.722" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.671" y="309.19" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.672" y="307.658" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.672" y="306.125" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.673" y="304.593" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.673" y="303.061" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.674" y="301.528" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.675" y="299.996" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.604" y="323.747" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.605" y="322.214" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.606" y="320.682" fill="#010101" width="2.297" height="0.661" />
        <rect x="250.606" y="319.15" fill="#010101" width="2.297" height="0.661" />
        <rect x="250.607" y="317.618" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.608" y="316.085" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.609" y="314.552" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.609" y="313.02" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.664" y="322.988" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.665" y="321.456" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.666" y="319.923" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.666" y="318.391" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.667" y="316.859" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.668" y="315.327" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.669" y="313.795" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.669" y="312.262" fill="#010101" width="2.297" height="0.661" />
        <rect x="250.598" y="336.022" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.599" y="334.49" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.6" y="332.958" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.601" y="331.425" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.601" y="329.893" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.602" y="328.361" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.603" y="326.829" fill="#010101" width="2.297" height="0.661" />
        <rect x="250.604" y="325.296" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.658" y="335.264" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.659" y="333.732" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.66" y="332.199" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.661" y="330.667" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.661" y="329.134" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.662" y="327.602" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.663" y="326.07" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.663" y="324.538" fill="#010101" width="2.297" height="0.661" />
        <rect x="250.592" y="348.277" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.593" y="346.745" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.594" y="345.212" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.595" y="343.679" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.595" y="342.147" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.596" y="340.615" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.597" y="339.083" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.598" y="337.55" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.652" y="347.518" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.653" y="345.986" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.654" y="344.454" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.655" y="342.921" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.655" y="341.389" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.656" y="339.857" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.657" y="338.324" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.658" y="336.792" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.587" y="360.546" fill="#010101" width="2.297" height="0.661" />
        <rect x="250.588" y="359.014" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.589" y="357.482" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.589" y="355.949" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.589" y="354.416" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.59" y="352.884" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.591" y="351.352" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.592" y="349.82" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.647" y="359.788" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.647" y="358.255" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.648" y="356.723" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.649" y="355.191" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.65" y="353.659" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.65" y="352.127" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.651" y="350.593" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.652" y="349.061" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.581" y="372.812" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.582" y="371.28" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.583" y="369.748" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.583" y="368.215" fill="#010101" width="2.297" height="0.661" />
        <rect x="250.584" y="366.682" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.585" y="365.15" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.586" y="363.618" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.586" y="362.085" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.641" y="372.053" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.642" y="370.521" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.642" y="368.989" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.643" y="367.457" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.644" y="365.924" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.645" y="364.392" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.645" y="362.86" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.646" y="361.327" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.575" y="385.062" fill="#010101" width="2.297" height="0.661" />
        <rect x="250.576" y="383.53" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.577" y="381.998" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.577" y="380.465" fill="#010101" width="2.297" height="0.661" />
        <rect x="250.578" y="378.932" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.579" y="377.4" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.58" y="375.868" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.58" y="374.335" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.635" y="384.303" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.636" y="382.771" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.636" y="381.239" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.637" y="379.707" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.638" y="378.174" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.639" y="376.642" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.639" y="375.11" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.64" y="373.577" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.57" y="397.316" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.57" y="395.784" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.571" y="394.251" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.572" y="392.719" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.572" y="391.187" fill="#010101" width="2.297" height="0.661" />
        <rect x="250.573" y="389.655" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.574" y="388.123" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.574" y="386.589" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.63" y="396.558" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.63" y="395.025" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.63" y="393.493" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.632" y="391.96" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.632" y="390.428" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.633" y="388.896" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.633" y="387.364" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.634" y="385.831" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.711" y="98.326" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.712" y="96.793" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.713" y="95.261" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.771" y="97.568" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.771" y="96.035" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.772" y="94.502" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.705" y="110.595" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.706" y="109.063" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.707" y="107.531" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.707" y="105.999" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.708" y="104.466" fill="#010101" width="2.297" height="0.661" />
        <rect x="250.709" y="102.934" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.71" y="101.402" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.71" y="99.869" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.765" y="109.837" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.766" y="108.305" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.766" y="106.772" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.767" y="105.24" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.768" y="103.707" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.769" y="102.175" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.769" y="100.643" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.77" y="99.111" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.699" y="122.861" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.7" y="121.329" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.701" y="119.796" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.701" y="118.264" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.702" y="116.732" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.703" y="115.2" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.704" y="113.668" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.704" y="112.135" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.759" y="122.103" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.76" y="120.571" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.76" y="119.039" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.761" y="117.505" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.762" y="115.973" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.763" y="114.441" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.763" y="112.909" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.764" y="111.377" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.693" y="135.111" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.694" y="133.579" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.695" y="132.046" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.696" y="130.514" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.696" y="128.982" fill="#010101" width="2.297" height="0.661" />
        <rect x="250.697" y="127.45" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.698" y="125.918" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.698" y="124.385" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.754" y="134.353" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.754" y="132.821" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.755" y="131.288" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.755" y="129.755" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.757" y="128.223" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.757" y="126.691" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.758" y="125.159" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.758" y="123.626" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.688" y="147.366" fill="#010101" width="2.297" height="0.661" />
        <rect x="250.688" y="145.834" fill="#010101" width="2.297" height="0.661" />
        <rect x="250.689" y="144.301" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.69" y="142.768" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.691" y="141.236" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.691" y="139.704" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.692" y="138.171" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.693" y="136.639" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.748" y="146.607" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.748" y="145.075" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.749" y="143.543" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.75" y="142.01" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.751" y="140.478" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.751" y="138.946" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.752" y="137.413" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.753" y="135.88" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.682" y="159.635" fill="#010101" width="2.297" height="0.661" />
        <rect x="250.682" y="158.103" fill="#010101" width="2.297" height="0.661" />
        <rect x="250.683" y="156.571" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.684" y="155.038" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.685" y="153.505" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.685" y="151.973" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.686" y="150.441" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.687" y="148.909" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.742" y="158.877" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.742" y="157.344" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.743" y="155.812" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.744" y="154.28" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.745" y="152.748" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.745" y="151.215" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.746" y="149.682" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.747" y="148.15" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.676" y="171.901" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.677" y="170.369" fill="#010101" width="2.297" height="0.661" />
        <rect x="250.677" y="168.836" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.678" y="167.304" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.679" y="165.771" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.68" y="164.239" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.68" y="162.707" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.681" y="161.174" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.736" y="171.142" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.737" y="169.61" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.738" y="168.078" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.738" y="166.545" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.739" y="165.013" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.74" y="163.481" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.74" y="161.949" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.741" y="160.415" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.671" y="184.176" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.671" y="182.644" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.672" y="181.112" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.673" y="179.58" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.674" y="178.047" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.674" y="176.515" fill="#010101" width="2.297" height="0.661" />
        <rect x="250.674" y="174.983" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.675" y="173.451" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.73" y="183.418" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.731" y="181.886" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.732" y="180.353" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.732" y="178.821" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.733" y="177.289" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.734" y="175.756" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.734" y="174.224" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.735" y="172.692" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.665" y="196.431" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.665" y="194.899" fill="#010101" width="2.297" height="0.661" />
        <rect x="250.666" y="193.366" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.667" y="191.833" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.668" y="190.301" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.668" y="188.769" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.669" y="187.237" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.67" y="185.704" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.724" y="195.672" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.725" y="194.14" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.726" y="192.608" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.726" y="191.076" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.727" y="189.543" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.728" y="188.01" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.729" y="186.478" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.729" y="184.946" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.659" y="208.701" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.659" y="207.168" fill="#010101" width="2.297" height="0.661" />
        <rect x="250.66" y="205.635" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.661" y="204.103" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.662" y="202.571" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.662" y="201.039" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.663" y="199.506" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.664" y="197.974" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.718" y="207.942" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.719" y="206.41" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.72" y="204.877" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.721" y="203.345" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.721" y="201.813" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.722" y="200.28" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.723" y="198.747" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.723" y="197.215" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.653" y="220.966" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.654" y="219.434" fill="#010101" width="2.297" height="0.661" />
        <rect x="250.654" y="217.902" fill="#010101" width="2.297" height="0.661" />
        <rect x="250.655" y="216.37" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.656" y="214.836" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.656" y="213.304" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.657" y="211.772" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.658" y="210.24" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.713" y="220.207" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.714" y="218.675" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.715" y="217.143" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.715" y="215.611" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.715" y="214.079" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.716" y="212.546" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.717" y="211.014" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.718" y="209.481" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.647" y="233.216" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.648" y="231.684" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.649" y="230.152" fill="#010101" width="2.297" height="0.661" />
        <rect x="250.649" y="228.619" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.65" y="227.086" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.65" y="225.554" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.651" y="224.022" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.652" y="222.49" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.707" y="232.457" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.708" y="230.925" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.709" y="229.393" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.709" y="227.861" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.71" y="226.329" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.711" y="224.796" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.712" y="223.263" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.712" y="221.731" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.641" y="245.47" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.642" y="243.938" fill="#010101" width="2.296" height="0.662" />
        <rect x="250.643" y="242.406" fill="#010101" width="2.297" height="0.662" />
        <rect x="250.643" y="240.874" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.644" y="239.341" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.645" y="237.809" fill="#010101" width="2.296" height="0.661" />
        <rect x="250.646" y="236.277" fill="#010101" width="2.297" height="0.661" />
        <rect x="250.646" y="234.744" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.701" y="244.712" fill="#010101" width="2.297" height="0.661" />
        <rect x="249.702" y="243.179" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.703" y="241.647" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.703" y="240.115" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.704" y="238.583" fill="#010101" width="2.297" height="0.662" />
        <rect x="249.705" y="237.05" fill="#010101" width="2.296" height="0.662" />
        <rect x="249.706" y="235.518" fill="#010101" width="2.296" height="0.661" />
        <rect x="249.706" y="233.986" fill="#010101" width="2.297" height="0.661" />
        <path
          fill="#010101"
          d="M252.887,72.64c-0.01-0.322-0.284-0.591-0.608-0.591h-0.009v0.622h0.102l0.229,2.8h-2.506l0.231-2.8h0.104
     v-0.622h-0.048c-0.326,0-0.601,0.269-0.608,0.591l-0.36,20.706c-0.011,0.323,0.247,0.592,0.573,0.592h2.705
     c0.326,0,0.584-0.269,0.573-0.592L252.887,72.64z M250.207,77.488c0.001-0.22,0.179-0.395,0.396-0.395h1.475
     c0.217,0,0.395,0.175,0.395,0.395l-0.001,1.473c0,0.221-0.179,0.396-0.395,0.396h-1.475c-0.217,0-0.395-0.175-0.395-0.396V77.488z
      M251.34,93.264c-0.721,0-1.305-0.584-1.304-1.306c0-0.717,0.584-1.301,1.305-1.301s1.304,0.584,1.304,1.301
     C252.644,92.68,252.061,93.264,251.34,93.264"
        />
        <rect x="250.66" y="70.293" fill="#010101" width="1.379" height="3.401" />
        <path
          fill="#010101"
          d="M254.339,71.136c0.001-1.568-1.269-2.839-2.835-2.839h-0.306c-1.566,0-2.837,1.271-2.838,2.839
     c0,0.291,0.044,0.572,0.126,0.837h-0.001c0.001,0.002,0.001,0.004,0.002,0.006c0,0.001,0.001,0.002,0.001,0.002
     c0.281,0.74,0.279,1.818,0.278,2.85h0.007c0.035,0.568,0.304,1.071,0.712,1.415l0.123-3.832c0.01-0.338,0.313-0.613,0.671-0.613
     h0.151l0.001-1.749h1.84l-0.001,1.749h0.107c0.358,0,0.661,0.275,0.673,0.613l0.133,3.857c0.423-0.346,0.705-0.86,0.741-1.44h0.004
     v-0.082c0.001-0.015,0.003-0.03,0.003-0.046c0-0.014-0.002-0.029-0.003-0.043c0.002-0.957,0.016-1.931,0.264-2.628
     C254.286,71.75,254.339,71.449,254.339,71.136"
        />
        <rect x="249.847" y="439.682" fill="#010101" width="2.936" height="1.298" />
        <path
          fill="#010101"
          d="M251.755,445.071h-0.886c-0.941,0-1.705-0.764-1.704-1.707l0.001-2.162h4.296l-0.001,2.162
     C253.461,444.307,252.697,445.071,251.755,445.071"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
     M102.977,440.852c-2.873-1.746-5.962-3.122-9.128-4.241c-4.369-1.543-8.903-2.607-13.476-3.336l-4.281-0.617"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="M51.67,433.727
     c2.734-0.568,5.509-0.985,8.283-1.293c2.212-0.246,4.438-0.414,6.664-0.407c2.76,0.009,5.55,0.198,8.322,0.506"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
     M398.452,440.852c2.873-1.746,5.962-3.122,9.128-4.241c4.369-1.543,8.903-2.607,13.476-3.336l4.281-0.617"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
     M449.759,433.727c-2.734-0.568-5.509-0.985-8.283-1.293c-2.212-0.246-4.438-0.414-6.664-0.407c-2.759,0.009-5.55,0.198-8.322,0.506
     "
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
     M178.004,400.902c-3.626,0-11.788-1.877-13.388-2.253l-2.119-0.489l0.354-2.161L181.55,298.9l1.841-0.076
     c0.311-0.019,0.793-0.02,0.959-0.02c2.211,0,7.954,0.241,13.518,2.472l1.76,0.732l-0.348,1.853
     c-0.134,0.757-16.576,89.796-17.736,94.904c-0.131,0.604-0.501,1.159-1.038,1.548C179.853,400.742,179.128,400.902,178.004,400.902
     z"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
     M323.328,400.902c3.626,0,11.788-1.877,13.388-2.253l2.119-0.489l-0.354-2.161L319.782,298.9l-1.841-0.076
     c-0.311-0.019-0.793-0.02-0.959-0.02c-2.211,0-7.954,0.241-13.518,2.472l-1.76,0.732l0.348,1.853
     c0.134,0.757,16.576,89.796,17.736,94.904c0.131,0.604,0.501,1.159,1.038,1.548C321.479,400.742,322.204,400.902,323.328,400.902z"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="M200.999,54.608
     c0.948-1.485,2.503-2.291,3.723-2.716c2.886-1.011,6.106-1.626,9.22-2.221c0,0,1.894-0.365,2.304-0.447
     c1.316-0.269,2.636-0.517,3.955-0.765c7.069-1.293,13.609-2.17,19.982-2.683c4.013-0.321,7.95-0.484,11.698-0.484
     c3.296,0,6.501,0.126,9.527,0.375c4.623,0.378,9.314,1.178,13.85,1.953l1.137,0.193c2.06,0.35,4.162,0.706,6.241,1.018
     c0.972,0.134,2.004,0.266,3.085,0.397c5.15,0.626,12.08,1.469,14.983,5.155"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="M199.209,60.299
     c2.814,3.646,7.025,8.847,12.516,9.211c2.021,0.134,4.346,0.202,6.912,0.202c7.569,0,14.705-0.578,14.776-0.584
     c2.71-0.248,7.995-0.663,10.729-0.663c0.86,0,1.111,0.044,1.121,0.046c0.186,0.044,0.32,0.109,0.414,0.175l-0.01,26.166
     c-0.083,0.008-0.166,0.014-0.248,0.022c-4.017,0.381-7.629,0.565-11.058,0.565c-2.506,0-4.933-0.105-7.214-0.309
     c-1.903-0.174-3.685-0.425-5.295-0.746c-5.657-1.101-10.745-3.264-14.725-6.259c-1.83-1.375-3.356-2.863-4.538-4.425
     c-0.513-0.672-0.877-1.238-1.151-1.79"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="M201.508,88.383
     c-18.989,2.774-34.566,8.453-48.945,17.83c-9.893,6.452-17.319,17.466-19.039,20.15c3.032,11.553,5.806,23.181,8.265,34.639
     l0.934,5.204c0,0,14.074,64.785,10.814,89.526"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          points="
     245.933,98.331 245.914,152.75 245.933,157.585 245.722,441.807 	"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="M128.5,109.973
     c0,0,1.883,6.114,3.704,12.944"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
     M372.429,109.973c0,0-1.882,6.114-3.703,12.944"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
     M244.873,438.519c-1.559,0.179-3.213,0.052-4.74-0.06c-2.028-0.147-4.042-0.42-6.062-0.643c-1.935-0.213-3.87-0.426-5.804-0.639
     c-2.662-0.293-5.323-0.586-7.984-0.878c-3.122-0.343-6.244-0.687-9.365-1.031c-3.318-0.364-6.637-0.729-9.955-1.095
     c-3.249-0.357-6.499-0.715-9.748-1.072c-2.916-0.321-5.832-0.642-8.747-0.963l-6.952-0.765l-4.363-0.48
     c-0.364-0.04-0.728-0.08-1.093-0.12c-3.809-0.419-7.535-1.398-11.042-2.94c-4.287-1.883-9.324-4.747-10.697-8.218"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
     M245.073,434.884c-1.414,0.107-2.887-0.005-4.258-0.104c-2.027-0.148-4.042-0.422-6.061-0.644c-1.936-0.213-3.87-0.426-5.806-0.639
     c-2.661-0.293-5.321-0.586-7.982-0.878l-9.367-1.031c-3.318-0.365-6.635-0.729-9.954-1.095c-3.25-0.357-6.499-0.714-9.748-1.072
     c-2.916-0.321-5.832-0.642-8.748-0.963l-6.952-0.764c-1.453-0.161-2.907-0.321-4.361-0.481c-0.365-0.04-0.73-0.08-1.094-0.12
     c-3.809-0.419-7.534-1.397-11.043-2.939c-4.975-2.187-10.962-5.695-11.056-9.94"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="M302.944,59.139
     c-2.24,3.89-6.657,9.673-12.147,10.037c-2.022,0.135-4.086,0.536-6.652,0.536c-7.569,0-14.705-0.578-14.776-0.584
     c-2.71-0.248-7.995-0.663-10.729-0.663c-0.86,0-1.111,0.044-1.121,0.046c-0.186,0.044-0.32,0.109-0.414,0.175l0.01,26.166
     c0.083,0.008,0.166,0.015,0.248,0.022c4.017,0.381,7.629,0.565,11.058,0.565c2.505,0,4.933-0.105,7.213-0.309
     c1.904-0.174,3.478-0.484,5.088-0.805c5.657-1.101,10.025-3.732,14.005-6.727c1.83-1.376,3.057-2.844,4.238-4.404
     c0.513-0.673,0.877-1.24,1.151-1.791"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          points="
     256.848,98.331 256.867,152.75 256.848,157.585 257.059,441.807 	"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
     M257.909,438.519c1.559,0.179,3.213,0.052,4.74-0.06c2.028-0.147,4.042-0.42,6.062-0.643c1.934-0.213,3.87-0.426,5.804-0.639
     c2.662-0.293,5.323-0.586,7.984-0.878c3.122-0.343,6.244-0.687,9.365-1.031c3.318-0.364,6.637-0.729,9.955-1.095
     c3.249-0.357,6.499-0.715,9.748-1.072c2.916-0.321,5.832-0.642,8.747-0.963l6.952-0.765l4.363-0.48
     c0.364-0.04,0.728-0.08,1.093-0.12c3.809-0.419,7.535-1.398,11.042-2.94c4.287-1.883,9.324-4.747,10.697-8.218"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
     M257.709,434.884c1.414,0.107,2.887-0.005,4.258-0.104c2.027-0.148,4.042-0.422,6.061-0.644c1.936-0.213,3.87-0.426,5.806-0.639
     c2.661-0.293,5.321-0.586,7.982-0.878l9.367-1.031c3.318-0.365,6.635-0.729,9.954-1.095c3.25-0.357,6.499-0.714,9.748-1.072
     c2.916-0.321,5.832-0.642,8.748-0.963l6.952-0.764c1.453-0.161,2.907-0.321,4.361-0.481c0.365-0.04,0.73-0.08,1.094-0.12
     c3.809-0.419,7.534-1.397,11.043-2.939c4.975-2.187,10.962-5.695,11.056-9.94"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
     M347.589,255.732c-3.26-24.74,10.814-89.525,10.814-89.525l1.579-5.827c2.459-11.458,4.945-22.664,7.977-34.216
     c-1.721-2.685-9.146-13.699-19.039-20.151c-14.379-9.377-29.956-15.055-48.945-17.83"
        />
        <path
          fill="#010101"
          d="M450.876,446.638c-0.21-3.209-3.389-51.19-6.28-62.74c-3.019-12.08-6.99-40.92-7.99-51.95
     c-1.02-11.16-14.01-85.07-17.029-92.1c-1.231-2.88-5.59-18.74-10.63-37.1c-7.061-25.7-15.841-57.68-19.37-65.9
     c-4.09-9.57-9.67-18.33-12.67-23.03c-1.21-1.91-2.25-3.55-2.301-3.84c0-1.36-11.89-11.23-23.379-16.969
     c-11.36-5.681-47.011-15.321-50.551-16.271c0.551-2.149,1.01-4.34,1.45-6.46c0.22-1.05,0.441-2.099,0.67-3.15
     c0.191-0.869,0.451-1.77,0.691-2.63c0.649-2.27,1.32-4.62,1.01-7.06c-1.121-8.71-11.281-9.94-18.701-10.84
     c-1.059-0.13-2.08-0.25-3.009-0.39c-2.39-0.36-4.821-0.77-7.17-1.18c-4.651-0.79-9.451-1.61-14.231-2.01
     c-6.599-0.54-13.889-0.5-21.659,0.12c-6.49,0.52-13.11,1.41-20.261,2.72c-1.33,0.24-2.659,0.5-3.989,0.77
     c-0.74,0.14-1.5,0.29-2.261,0.43c-3.21,0.621-6.54,1.26-9.62,2.34c-3.58,1.25-5.75,3.64-6.269,6.91
     c-0.611,3.88,0.299,7.76,1.179,11.51l0.27,1.12c0.621,2.68,1.281,5.3,1.971,7.8c-3.581,0.97-39.19,10.59-50.541,16.271
     c-11.49,5.739-23.379,15.609-23.379,16.949c-0.051,0.31-1.1,1.95-2.311,3.86c-2.99,4.7-8.569,13.46-12.67,23.03
     c-3.519,8.22-12.309,40.2-19.369,65.9c-5.041,18.36-9.391,34.22-10.631,37.1c-3.01,7.03-16.01,80.94-17.019,92.1
     c-1.01,11.03-4.981,39.87-7.991,51.95c-2.889,11.55-6.07,59.531-6.279,62.74c-0.131,0.11-0.221,0.27-0.23,0.46
     c-0.02,0.31,0.139,0.581,0.42,0.67c18.65,6.44,31.379,8.17,39.66,8.17c4.24,0,7.309-0.45,9.42-0.96
     c0.599-0.139,1.019-0.66,1.109-1.34l0.03,0.01c0.031-0.17,0.87-4.67,2.13-11.37l0.051-0.08c-0.011,0-0.021-0.01-0.03-0.01
     c3.67-19.41,10.929-57.17,12.909-62.72c2.261-6.31,17.4-62.2,19.35-72.94c1.411-7.74,10.54-35.25,16.23-50.58
     c-0.1,13.3-1.01,73.95-1.02,74.59l-1.92,74.56c-0.009,0.14-1.65,13.5-1.49,20.491c0.1,4.409,6.17,8,11.25,10.229
     c3.5,1.54,7.25,2.54,11.141,2.97l64.01,7.04c0.58,0.06,1.16,0.13,1.73,0.2c1.42,0.17,2.89,0.34,4.34,0.45h0.09
     c0.939,0.07,1.949,0.14,2.949,0.14c0.961,0,1.91-0.06,2.811-0.26c0.379-0.08,0.939-0.23,1.379-0.599
     c0.491-0.401,0.821-1.041,0.941-1.861c0.01-0.03,0.01-0.07,0.01-0.11c0.719-0.12,3.21-0.48,6.74-0.109
     c0.14,0.539,0.63,1.769,2.34,2.399c0.619,0.23,1.33,0.23,1.949,0.23h0.431c1.08,0,2.16-0.06,3.08-0.12
     c2.309-0.16,4.639-0.41,6.889-0.66l0.731-0.08c4.8-0.53,9.599-1.05,14.41-1.57l18.529-1.99c2.891-0.31,5.84-0.57,8.7-0.82
     c7.54-0.67,15.34-1.37,22.861-3.02l0.82-0.18c6.56-1.43,18.77-4.09,18.949-12.279c0.111-5.021-0.689-13.211-1.17-17.651
     c-0.219-1.99-0.359-4.04-0.41-6.11l-1.83-71.29c-0.01-0.64-0.93-61.29-1.029-74.59c5.689,15.33,14.83,42.84,16.24,50.58
     c1.949,10.74,17.079,66.63,19.34,72.94c1.989,5.55,9.25,43.31,12.92,62.72c-0.01,0-0.021,0.01-0.03,0.01l0.04,0.08
     c1.269,6.7,2.099,11.2,2.139,11.37l0.021-0.01c0.099,0.68,0.519,1.201,1.119,1.34c2.1,0.51,5.181,0.96,9.42,0.96
     c8.281,0,21.011-1.73,39.66-8.17c0.27-0.089,0.44-0.36,0.42-0.67C451.096,446.908,451.006,446.748,450.876,446.638 M350.936,93.589
     c11.721,5.859,22.61,15.219,23.011,16.369c-1.46,5.16-2.851,10.301-4.191,15.41c-1.74-2.79-9.3-14.26-19.8-21.17
     c-14.74-9.7-30.729-15.53-50.24-18.33c0.17-0.21,0.351-0.43,0.511-0.65c0.58-0.76,0.979-1.37,1.289-1.98l0.061-0.12
     c0.82-1.64-0.18-4.41-0.71-5.65C306.046,78.858,339.956,88.098,350.936,93.589 M303.846,57.518c0.301,2.31-0.349,4.59-0.979,6.8
     c-0.25,0.88-0.511,1.78-0.701,2.67c-0.24,1.06-0.46,2.11-0.669,3.16c-0.44,2.111-0.901,4.29-1.451,6.43l-0.38-0.1l0.321,0.64
     c0.019,0.04,1.92,3.88,1,5.71l-0.051,0.11c-0.289,0.58-0.67,1.16-1.23,1.89c-0.229,0.32-0.479,0.63-0.74,0.931h-0.05l-0.009,0.069
     c-0.721,0.84-1.54,1.67-2.451,2.46c-1.69,1.48-3.649,2.82-5.82,3.971c-5.43,2.879-11.729,4.489-18.729,4.779
     c-2.59,0.11-5.43,0.06-8.66-0.15l-1.081-0.07c-2.28-0.139-4.64-0.29-6.9-0.71l0.01-27.78c0-0.06,0.15-1.489,1.52-1.8
     c1.281-0.3,8.14,0.58,10.691,0.94c0.13,0.01,12.66,0.95,21.539,0.371c7.961-0.531,12.881-10.181,14.11-12.881
     C303.477,55.728,303.727,56.578,303.846,57.518 M150.497,93.589c10.969-5.491,44.879-14.731,50.07-16.121
     c-0.53,1.24-1.53,4.01-0.711,5.65c0.341,0.67,0.78,1.36,1.381,2.16c0.16,0.2,0.33,0.401,0.49,0.59
     c-19.521,2.8-35.511,8.63-50.261,18.33c-10.45,6.88-17.889,18.11-19.79,21.17c-1.34-5.109-2.729-10.24-4.189-15.4
     C127.977,108.728,138.817,99.429,150.497,93.589 M99.676,454.348c-6.16,1.47-20.67,2.491-48.66-7.21
     c5.721-1.16,25.75-4.09,48.75,5.291c0.45,0.179,0.58,0.669,0.551,1.039C100.287,453.828,100.106,454.248,99.676,454.348
      M100.567,452.248c-0.151-0.18-0.33-0.34-0.551-0.43c-22.75-9.27-42.619-6.59-48.8-5.389c0.091-1.271,0.361-5.311,0.761-10.801
     c2.52-0.52,5.14-0.92,8.01-1.24c2.539-0.28,4.639-0.44,6.63-0.41c4.059,0.01,8.54,0.42,13.71,1.25
     c4.92,0.781,9.309,1.87,13.41,3.32c3.26,1.15,6.09,2.461,8.649,3.97C101.546,446.998,100.897,450.458,100.567,452.248
      M134.737,306.418c-1.95,10.72-17.061,66.53-19.321,72.83c-2.019,5.65-9.219,43.091-12.9,62.6c-2.55-1.49-5.35-2.78-8.56-3.91
     c-4.139-1.47-8.57-2.56-13.53-3.36c-5.199-0.83-9.71-1.23-13.809-1.25c-2.011-0.01-4.14,0.13-6.701,0.41
     c-2.82,0.31-5.41,0.72-7.89,1.22c1.171-15.81,3.381-42.68,5.44-50.91c3.021-12.1,7-41,8-52.05
     c1.021-11.14,13.981-84.89,16.981-91.9c1.25-2.919,5.61-18.79,10.659-37.18c7.06-25.68,15.83-57.64,19.341-65.82
     c4.079-9.509,9.639-18.24,12.62-22.94c1.029-1.61,1.649-2.6,2.01-3.229c9.75,34.639,16.82,67.929,21.589,101.739
     c1.901,13.45,2.951,28.15,2.951,41.4C145.987,269.009,136.206,298.358,134.737,306.418 M247.287,440.498v0.69
     c0.009,0.87,0.02,1.77-0.111,2.61c-0.07,0.461-0.25,1.08-0.719,1.461c-0.331,0.279-0.791,0.399-1.101,0.469
     c-1.76,0.38-3.789,0.23-5.569,0.1h-0.09c-1.441-0.11-2.901-0.28-4.311-0.45c-0.579-0.06-1.159-0.13-1.739-0.199l-64.011-7.041
     c-3.819-0.42-7.51-1.4-10.95-2.91c-4.91-2.16-10.77-5.58-10.859-9.65c-0.161-6.95,1.469-20.26,1.49-20.43l1.92-74.6
     c0.01-0.68,1.029-68.52,1.029-76.43c0-13.29-1.05-28.04-2.949-41.54c-4.07-28.84-9.82-57.31-17.471-86.54l0.131,0.07
     c0.859-1.42,8.77-14.07,19.85-21.36c14.769-9.72,30.779-15.53,50.38-18.29c1.129,1.29,2.459,2.51,3.979,3.66
     c4.2,3.15,9.541,5.43,15.45,6.59c1.731,0.34,3.561,0.59,5.45,0.76c5.401,0.49,11.391,0.41,18.29-0.25
     c0.67-0.06,1.34-0.129,2.01-0.209L247.287,440.498z M247.386,96.358c-0.689,0.08-1.38,0.151-2.069,0.22
     c-6.87,0.65-12.811,0.73-18.181,0.25c-1.86-0.17-3.67-0.43-5.38-0.76c-5.809-1.139-11.059-3.38-15.179-6.47
     c-1.93-1.45-3.551-3.04-4.821-4.71c-0.58-0.77-1-1.42-1.32-2.06c-0.91-1.83,0.98-5.67,1-5.71l0.32-0.64l-0.38,0.1
     c-0.69-2.5-1.35-5.11-1.969-7.78l-0.26-1.13c-0.871-3.69-1.771-7.51-1.181-11.25c0.06-0.35,0.151-0.659,0.241-0.98
     c1.339,2.76,6.339,11.88,14.2,12.401c8.88,0.579,20.74-0.361,20.859-0.381c3.631-0.33,10.82-0.869,12.16-0.56
     c1.37,0.33,1.87,1.25,1.971,1.47L247.386,96.358z M254.516,443.018c-3.34-0.33-5.72-0.05-6.63,0.1c0.05-0.65,0.061-1.3,0.061-1.939
     l0.099-372.881l-0.02-0.11c-0.02-0.06-0.56-1.48-2.449-1.92c-1.781-0.42-11.93,0.51-12.361,0.55
     c-0.12,0.01-11.929,0.95-20.769,0.37c-8.12-0.54-13.281-11.19-13.931-12.61c1.101-2.56,3.381-3.899,5.301-4.569
     c3.029-1.061,6.33-1.701,9.529-2.311c0.76-0.14,1.51-0.29,2.26-0.439c1.33-0.261,2.65-0.521,3.98-0.761
     c7.121-1.31,13.731-2.2,20.201-2.71c7.729-0.62,14.979-0.66,21.54-0.12c4.759,0.39,9.549,1.21,14.179,2.011
     c2.35,0.399,4.781,0.809,7.191,1.169c0.929,0.14,1.95,0.26,3.019,0.39c6.101,0.74,14.071,1.73,17.04,6.98
     c-0.679,1.541-5.689,12.43-13.769,12.97c-8.851,0.58-21.33-0.36-21.43-0.37c-0.381-0.05-9.23-1.309-10.91-0.92
     c-1.471,0.33-1.971,1.7-2.021,2.4L254.516,443.018z M350.197,330.558l1.829,71.29c0.051,2.081,0.19,4.161,0.41,6.161
     c0.48,4.42,1.28,12.58,1.17,17.569c-0.17,7.681-12.049,10.261-18.44,11.65l-0.82,0.18c-7.479,1.65-15.26,2.34-22.779,3.01
     c-2.861,0.25-5.82,0.511-8.711,0.82l-18.529,2c-4.811,0.521-9.611,1.03-14.411,1.56l-0.73,0.08c-2.25,0.25-4.569,0.51-6.859,0.66
     c-0.971,0.06-2.1,0.15-3.241,0.12h-0.219c-0.601,0-1.22,0-1.741-0.19c-1.77-0.66-1.96-2.07-1.96-2.09l0.1-346.61
     c2.26,0.4,4.601,0.56,6.86,0.7l1.081,0.07c3.259,0.21,6.11,0.26,8.729,0.15c7.09-0.3,13.49-1.929,19.011-4.86
     c2.21-1.17,4.21-2.53,5.939-4.05c0.861-0.75,1.63-1.53,2.33-2.32c19.601,2.76,35.62,8.57,50.39,18.29
     c10.69,7.03,18.33,18.9,19.75,21.21l0.291-0.18c-7.681,29.33-13.45,57.87-17.53,86.8c-1.911,13.5-2.96,28.25-2.96,41.54
     C349.157,262.028,350.186,329.868,350.197,330.558 M386.016,379.248c-2.26-6.3-17.369-62.11-19.319-72.83
     c-1.47-8.06-11.261-37.409-16.89-52.35c0.01-13.25,1.049-27.95,2.949-41.4c4.77-33.82,11.84-67.11,21.6-101.739
     c0.35,0.629,0.98,1.619,2,3.229c2.99,4.7,8.551,13.431,12.631,22.94c3.5,8.18,12.279,40.14,19.33,65.82
     c5.05,18.39,9.42,34.261,10.67,37.18c3,7.01,15.96,80.76,16.969,91.9c1.01,11.05,4.98,39.95,8.01,52.05
     c2.06,8.23,4.271,35.1,5.431,50.91c-1.801-0.369-3.771-0.69-6-0.99c-4.811-0.64-9.261-0.75-13.601-0.35
     c-0.58,0.05-1.16,0.09-1.75,0.141c-0.86,0.059-1.719,0.129-2.58,0.219c-2.84,0.32-5.67,0.76-8.399,1.32
     c-3.631,0.75-6.91,1.66-10.01,2.78c-3.041,1.101-5.711,2.34-8.141,3.77C395.227,422.339,388.037,384.898,386.016,379.248
      M399.037,442.518c2.46-1.45,5.149-2.71,8.239-3.82c3.07-1.12,6.32-2.019,9.921-2.76c2.71-0.56,5.519-1,8.34-1.31
     c0.849-0.1,1.71-0.16,2.559-0.22c0.59-0.05,1.18-0.09,1.76-0.149c4.291-0.391,8.69-0.281,13.461,0.359
     c2.289,0.3,4.289,0.63,6.13,1.01c0.409,5.49,0.679,9.53,0.759,10.801c-6.169-1.201-26.04-3.881-48.79,5.389
     c-0.219,0.09-0.4,0.25-0.549,0.43C400.526,450.458,399.886,446.998,399.037,442.518 M450.477,447.158
     c-28.041,9.681-42.561,8.66-48.721,7.19c-0.439-0.1-0.62-0.52-0.65-0.88c-0.02-0.37,0.1-0.86,0.551-1.039
     c12.91-5.261,24.88-6.651,33.91-6.651c7.139,0,12.449,0.87,14.93,1.37L450.477,447.158z"
        />
        <path
          fill="#010101"
          d="M197.217,303.217c-6.6-2.659-13.58-2.319-13.65-2.319l-0.25,0.019l-18.39,95.481l-0.06,0.309l0.3,0.071
     c1.79,0.42,9.62,2.21,12.93,2.21c0.63,0,1.1-0.071,1.33-0.22c0.19-0.12,0.25-0.27,0.259-0.36c1.17-5.16,17.561-93.941,17.731-94.83
     l0.05-0.26L197.217,303.217z M182.627,307.928c-1.45,13.73-5.691,46.67-15.79,81.989L182.627,307.928z M179.077,398.228
     c-0.62,0.56-7.25-0.57-13.42-2c14.13-46.57,17.91-90.72,18.23-94.681c1.33-0.039,7.19-0.029,12.84,2.17
     C195.737,309.108,180.186,393.258,179.077,398.228"
        />
        <path
          fill="#010101"
          d="M318.227,300.917l-0.25-0.019c-0.07,0-7.051-0.34-13.65,2.319l-0.25,0.101l0.05,0.259
     c0.16,0.89,16.549,89.67,17.719,94.811c0.021,0.109,0.08,0.26,0.26,0.38c0.231,0.149,0.701,0.219,1.341,0.219
     c3.31,0,11.14-1.79,12.92-2.209l0.309-0.071L318.227,300.917z M334.707,389.928c-10.101-35.33-14.34-68.271-15.79-82
     L334.707,389.928z M322.487,398.258c-1.141-5-16.68-89.15-17.67-94.541c5.649-2.199,11.51-2.209,12.84-2.17
     c0.309,3.961,4.1,48.11,18.229,94.681C329.716,397.657,323.087,398.787,322.487,398.258"
        />
      </g>
    </svg>
  );
}
